import { gql } from '@efficiently/client-core-graphql-models';

export const GET_RECENTS = gql(`
	query GetRecents($collectionKey: RecentCollectionKey!) {
		recents(collectionKey: $collectionKey)
	}
`);

export const SET_RECENT = gql(`
	mutation SetRecent($input: SetRecentInput!) {
		setRecent(input: $input) {
			success
		}
	}
`);

export const REMOVE_RECENT = gql(`
	mutation RemoveRecent($input: RemoveRecentInput!) {
		removeRecent(input: $input) {
			success
		}
	}
`);

export const CLEAR_ALL_RECENTS = gql(`
	mutation ClearAllRecents($collectionKey: RecentCollectionKey!) {
		clearAllRecents(collectionKey: $collectionKey) {
			success
		}
	}
`);
